// this is aliased in webpack config based on server/client build
import { shopify } from '@/store/create-api'

export function fetchData(url) {
  return new Promise((resolve) => {
    fetch(`${window.baseFetchUrl}${url}.json`, { method: 'get' }).then((res) => {
      const data = res.json()

      resolve(data)
    })
  })
}

export function fetchProducts() {
  return new Promise((resolve, reject) => {
    shopify.product.fetchAll().then((res) => {
      if (!res) {
        reject()
        return
      }

      resolve(res)
    })
  })
}

export function createCheckout() {
  return new Promise((resolve) => {
    shopify.checkout.create().then((checkout) => {
      resolve(checkout)
    })
  })
}


function setParams(data) {
  const esc = encodeURIComponent
  const query = Object.keys(data)
    .map(k => `${esc(k)}=${esc(data[k])}`)
    .join('&')

  return query
}

export async function sendForm(data) {
  const res = await fetch(`https://www.getwearable.net/form/send.php?${setParams(data)}`, {
    method: 'get'
  })

  return res.json()
}

export async function sendNewsletter(data) {
  const res = await fetch(`https://www.getwearable.net/form/join.php?${setParams(data)}`, {
    method: 'get',
    mode: 'cors',
  })

  return res.json()
}




// WEBPACK FOOTER //
// ./src/store/api.js